import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children"];
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Container } from 'semantic-ui-react';
import { DEFAULT_SECTION_CLASSNAME } from './Section.constants';
import { classNames } from '../../../../utils/classname';
import useSemanticUiProps from '../../../foundation/hooks/use-semantic-ui-props';
import { ChildrenPropType } from '../../../foundation/types/component';
import './Section.less';
var defaultProps = {
  className: '',
  children: null
};
export default function Section(_ref) {
  var _classNames;
  var className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!children) {
    return null;
  }
  var _useSemanticUiProps = useSemanticUiProps(),
    getContainerProps = _useSemanticUiProps.getContainerProps;
  var finalClassName = classNames((_classNames = {}, _defineProperty(_classNames, DEFAULT_SECTION_CLASSNAME, true), _defineProperty(_classNames, className, true), _classNames));
  return /*#__PURE__*/React.createElement(Container, _extends({
    as: "section",
    className: finalClassName
  }, getContainerProps(rest)), children);
}
Section.defaultProps = defaultProps;